import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface DeviceSettingsFilterValues {
  name: string;
}

export const DeviceSettingsFilter = ({ children }: PropsWithChildren<any>) => {
  const filterItems: Item<DeviceSettingsFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<DeviceSettingsFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
    >
      {children}
    </FilterBar>
  );
};
